import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-lg p-8" }
const _hoisted_2 = { class: "text-center mb-8" }
const _hoisted_3 = { class: "text-3xl font-bold text-gray-800 mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_5 = { class: "mt-2 text-gray-600" }
const _hoisted_6 = {
  key: 1,
  class: "text-center py-8"
}
const _hoisted_7 = { class: "text-red-600" }
const _hoisted_8 = {
  href: "https://zenn.dev/sea_turt1e",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "mt-4 inline-block text-blue-600 hover:text-blue-800 underline"
}
const _hoisted_9 = {
  key: 2,
  class: "grid md:grid-cols-2 lg:grid-cols-3 gap-6"
}
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "text-lg font-semibold text-gray-800 mb-2 line-clamp-2" }
const _hoisted_12 = { class: "text-sm text-gray-600 mb-3 line-clamp-3" }
const _hoisted_13 = { class: "flex items-center justify-between text-xs text-gray-500 mb-3" }
const _hoisted_14 = { class: "flex items-center space-x-2" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "flex flex-wrap gap-1 mb-3" }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 3,
  class: "text-center mt-8"
}
const _hoisted_19 = {
  href: "https://zenn.dev/sea_turt1e",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-full hover:shadow-lg transition-shadow"
}
const _hoisted_20 = { class: "mt-12" }
const _hoisted_21 = { class: "bg-gray-50 rounded-lg p-6 text-center border border-gray-100 shadow-sm" }
const _hoisted_22 = { class: "text-2xl font-semibold text-gray-800 mb-2" }
const _hoisted_23 = { class: "text-gray-600 mb-6" }
const _hoisted_24 = {
  href: "https://speakerdeck.com/seaturt1e",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "inline-flex items-center justify-center gap-2 bg-gray-900 text-white py-3 px-6 rounded-full hover:bg-gray-800 transition-colors"
}
const _hoisted_25 = { class: "mt-12" }
const _hoisted_26 = { class: "bg-gray-50 rounded-lg p-6 border border-gray-100 shadow-sm" }
const _hoisted_27 = { class: "text-2xl font-semibold text-gray-800 mb-2 text-center" }
const _hoisted_28 = { class: "text-gray-600 mb-6 text-center" }
const _hoisted_29 = { class: "space-y-4" }
const _hoisted_30 = { class: "flex items-start gap-3" }
const _hoisted_31 = { class: "text-gray-500 text-sm ml-1" }
const _hoisted_32 = { class: "flex items-start gap-3" }
const _hoisted_33 = { class: "text-gray-500 text-sm ml-1" }
const _hoisted_34 = { class: "flex items-start gap-3" }
const _hoisted_35 = { class: "font-semibold text-gray-800" }
const _hoisted_36 = { class: "text-gray-700 ml-1" }
const _hoisted_37 = {
  href: "https://shizuoka.pycon.jp/2026/info",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "text-blue-600 hover:text-blue-800 hover:underline ml-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('articles.title')), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-20 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto rounded" }, null, -1))
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" }, null, -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('articles.loading')), 1)
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('articles.error')), 1),
            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('articles.viewOnZenn')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article) => {
              return (_openBlock(), _createElementBlock("article", {
                key: article.id,
                class: "bg-gray-50 rounded-lg p-6 hover:shadow-md transition-shadow border"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h3", _hoisted_11, _toDisplayString(article.title), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(article.body_letters_count > 100 ? article.body_letters_count + _ctx.$t('articles.characters') : ''), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(article.published_at)), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _cache[2] || (_cache[2] = _createElementVNode("svg", {
                          class: "w-4 h-4 mr-1",
                          fill: "currentColor",
                          viewBox: "0 0 20 20"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
                            "clip-rule": "evenodd"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(article.liked_count), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(article.topics, (topic) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: topic.name,
                        class: "inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded"
                      }, _toDisplayString(topic.name), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("a", {
                  href: article.path,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "inline-block w-full text-center bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition-colors text-sm"
                }, _toDisplayString(_ctx.$t('articles.readArticle')), 9, _hoisted_17)
              ]))
            }), 128))
          ])),
    (!_ctx.loading && !_ctx.error && _ctx.articles.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("a", _hoisted_19, _toDisplayString(_ctx.$t('articles.viewAll')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.$t('articles.speakerDeckTitle')), 1),
        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('articles.speakerDeckDescription')), 1),
        _createElementVNode("a", _hoisted_24, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", { d: "M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a1 1 0 0 1-1.447.894L12 17.618l-6.553 2.276A1 1 0 0 1 4 19V5Z" })
          ], -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('articles.viewOnSpeakerDeck')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t('articles.speakingHistoryTitle')), 1),
        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('articles.speakingHistoryDescription')), 1),
        _createElementVNode("ul", _hoisted_29, [
          _createElementVNode("li", _hoisted_30, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "flex-shrink-0 w-2 h-2 mt-2 bg-blue-600 rounded-full" }, null, -1)),
            _createElementVNode("div", null, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-semibold text-gray-800" }, "PyConJP 2025:", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("a", {
                href: "https://2025.pycon.jp/en/timetable/talk/ZVTUGM",
                target: "_blank",
                rel: "noopener noreferrer",
                class: "text-blue-600 hover:text-blue-800 hover:underline ml-1"
              }, " GraphRAG：グラフDBで強化したRAGによるLLM生成の実装 ", -1)),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('articles.speakingPoster')), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_32, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "flex-shrink-0 w-2 h-2 mt-2 bg-blue-600 rounded-full" }, null, -1)),
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-semibold text-gray-800" }, "Start Python Club:", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("a", {
                href: "https://startpython.connpass.com/event/371646/",
                target: "_blank",
                rel: "noopener noreferrer",
                class: "text-blue-600 hover:text-blue-800 hover:underline ml-1"
              }, " GraphRAG：グラフDBを使ったLLM生成（自作漫画DBを用いた具体例を使って） ", -1)),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('articles.speakingTalk')), 1)
            ])
          ]),
          _createElementVNode("li", _hoisted_34, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "flex-shrink-0 w-2 h-2 mt-2 bg-purple-600 rounded-full" }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_35, "PyCon mini Shizuoka 2026" + _toDisplayString(_ctx.$t('articles.speakingPlanned')) + ":", 1),
              _createElementVNode("span", _hoisted_36, [
                _createElementVNode("a", _hoisted_37, "DSPy入門" + _toDisplayString(_ctx.$t('articles.speakingTalk')), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}